<template>
  <div class="my-4 mx-1 company-info-container">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">公司信息</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card
      class="my-3 mx-1"
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
      <div slot="header">
        <span class="font-weight-bold text-primary">公司信息设置</span>
      </div>
      <div
        style="height: 470px;overflow-y: auto;padding-right: 60px"
        v-loading="loading"
      >
        <el-form
          :model="companyInfo"
          class="font-weight-bold"
          label-width="120px"
        >
          <el-form-item label="公司名称">
            <el-input v-model="companyInfo.companyName"></el-input>
          </el-form-item>
          <el-form-item label="公司地址">
            <el-input v-model="companyInfo.companyAddress"></el-input>
          </el-form-item>
          <el-form-item label="英文地址">
            <el-input v-model="companyInfo.companyAddressEn"></el-input>
          </el-form-item>
          <el-form-item label="商务合作电话">
            <el-input v-model="companyInfo.companyPhone"></el-input>
          </el-form-item>
          <el-form-item label="商务合作邮箱">
            <el-input v-model="companyInfo.companyEmail"></el-input>
          </el-form-item>
          <el-form-item label="市场合作电话">
            <el-input v-model="companyInfo.companyMarketPhone"></el-input>
          </el-form-item>
          <el-form-item label="市场合作邮箱">
            <el-input v-model="companyInfo.companyMarketEmail"></el-input>
          </el-form-item>
          <el-form-item label="万匠招聘电话">
            <el-input v-model="companyInfo.companyHrPhone"></el-input>
          </el-form-item>
          <el-form-item label="万匠招聘邮箱">
            <el-input v-model="companyInfo.companyHrEmail"></el-input>
          </el-form-item>
          <el-form-item label="QQ号码">
            <el-input v-model="companyInfo.companyQq"></el-input>
          </el-form-item>
          <el-form-item label="微信号">
            <el-input v-model="companyInfo.companyWx"></el-input>
          </el-form-item>
          <el-form-item label="微信二维码">
            <el-input v-model="companyInfo.wxEwm" placeholder="微信二维码 URL">
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(1)"
                ref="wxEwmUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸110*110像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail"
                :src="companyInfo.wxEwm"
                :preview-src-list="[companyInfo.wxEwm]"
                alt="微信二维码"
              />
            </div>
          </el-form-item>
          <el-form-item label="首页封面图片">
            <el-input
              v-model="companyInfo.companyCover"
              placeholder="首页封面图片URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(2)"
                ref="companyCoverUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸650*255像素</small>
            </div>
            <div class="mt-2">
              <el-image
                width="800"
                class="img-thumbnail"
                :src="companyInfo.companyCover"
                :preview-src-list="[companyInfo.companyCover]"
                alt="首页封面图片"
              />
            </div>
          </el-form-item>
          <el-form-item label="公司介绍">
            <my-editor v-model="companyInfo.companyIntroduction"></my-editor>
          </el-form-item>
          <el-form-item
            v-if="
              adminPermissions.includes(
                '/companyInformation/admin/updateCompanyInfo'
              )
            "
          >
            <el-button
              type="primary"
              @click="submitCompanyInfoForm(companyInfo)"
              >立即提交
            </el-button>
            <el-button @click="getCompanyInfo()">重置 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
import ImgUpload from "../../components/common/ImgUpload";
import MyEditor from "../../components/common/MyEditor";
export default {
  name: "CompanyInfo",
  data() {
    return {
      companyInfo: {
        wxEwm: "",
        companyCover: ""
      },
      adminPermissions: this.$store.state.adminPermissions,
      loading: false
    };
  },
  components: {
    ImgUpload,
    MyEditor
  },
  mounted() {
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo() {
      this.loading = true;
      this.axios.get("/companyInformation/admin/getCompanyInfo").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.companyInfo = resp.data.data;
          this.loading = false;
        }
      });
    },
    uploadImg(value) {
      if (value === 1) {
        this.companyInfo.wxEwm = this.$refs.wxEwmUpload.url;
      }
      if (value === 2) {
        this.companyInfo.companyCover = this.$refs.companyCoverUpload.url;
      }
    },
    submitCompanyInfoForm(companyInfo) {
      this.axios
        .post("/companyInformation/admin/updateCompanyInfo", {
          companyId: companyInfo.companyId,
          companyName: companyInfo.companyName,
          companyAddress: companyInfo.companyAddress,
          companyAddressEn: companyInfo.companyAddressEn,
          companyPhone: companyInfo.companyPhone,
          companyEmail: companyInfo.companyEmail,
          companyMarketPhone: companyInfo.companyMarketPhone,
          companyMarketEmail: companyInfo.companyMarketEmail,
          companyHrPhone: companyInfo.companyHrPhone,
          companyHrEmail: companyInfo.companyHrEmail,
          companyQq: companyInfo.companyQq,
          companyWx: companyInfo.companyWx,
          wxEwm: companyInfo.wxEwm,
          companyCover: companyInfo.companyCover,
          companyIntroduction: companyInfo.companyIntroduction
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success"
            });
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style lang="scss"></style>
